import { render, staticRenderFns } from "./ThemeRadios.vue?vue&type=template&id=157c36e8"
import script from "./ThemeRadios.vue?vue&type=script&lang=js"
export * from "./ThemeRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports